var C = g();
function g() {
  var t;
  return typeof window < "u" && !!((t = window.document) != null && t.createElement);
}
function u(t) {
  return t ? "self" in t ? t.document : t.ownerDocument || document : document;
}
function E(t, n = !1) {
  const { activeElement: e } = u(t);
  if (!(e != null && e.nodeName))
    return null;
  if (b(e) && e.contentDocument)
    return E(
      e.contentDocument.body,
      n
    );
  if (n) {
    const r = e.getAttribute("aria-activedescendant");
    if (r) {
      const o = u(e).getElementById(r);
      if (o)
        return o;
    }
  }
  return e;
}
function l(t, n) {
  return t === n || t.contains(n);
}
function b(t) {
  return t.tagName === "IFRAME";
}
function y(t) {
  const n = t.tagName.toLowerCase();
  return n === "button" ? !0 : n === "input" && t.type ? h.indexOf(t.type) !== -1 : !1;
}
var h = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function S(t) {
  if (typeof t.checkVisibility == "function")
    return t.checkVisibility();
  const n = t;
  return n.offsetWidth > 0 || n.offsetHeight > 0 || t.getClientRects().length > 0;
}
function f(t) {
  try {
    const n = t instanceof HTMLInputElement && t.selectionStart !== null, e = t.tagName === "TEXTAREA";
    return n || e || !1;
  } catch {
    return !1;
  }
}
function T(t) {
  return t.isContentEditable || f(t);
}
function v(t) {
  if (f(t))
    return t.value;
  if (t.isContentEditable) {
    const n = u(t).createRange();
    return n.selectNodeContents(t), n.toString();
  }
  return "";
}
function O(t) {
  let n = 0, e = 0;
  if (f(t))
    n = t.selectionStart || 0, e = t.selectionEnd || 0;
  else if (t.isContentEditable) {
    const r = u(t).getSelection();
    if (r != null && r.rangeCount && r.anchorNode && l(t, r.anchorNode) && r.focusNode && l(t, r.focusNode)) {
      const o = r.getRangeAt(0), i = o.cloneRange();
      i.selectNodeContents(t), i.setEnd(o.startContainer, o.startOffset), n = i.toString().length, i.setEnd(o.endContainer, o.endOffset), e = i.toString().length;
    }
  }
  return { start: n, end: e };
}
function p(t) {
  if (!t) return null;
  const n = (e) => e === "auto" || e === "scroll";
  if (t.clientHeight && t.scrollHeight > t.clientHeight) {
    const { overflowY: e } = getComputedStyle(t);
    if (n(e)) return t;
  } else if (t.clientWidth && t.scrollWidth > t.clientWidth) {
    const { overflowX: e } = getComputedStyle(t);
    if (n(e)) return t;
  }
  return p(t.parentElement) || document.scrollingElement || document.body;
}
function x(t, n) {
  const e = t.map((o, i) => [i, o]);
  let r = !1;
  return e.sort(([o, i], [a, d]) => {
    const c = n(i), s = n(d);
    return c === s || !c || !s ? 0 : N(c, s) ? (o > a && (r = !0), -1) : (o < a && (r = !0), 1);
  }), r ? e.map(([o, i]) => i) : t;
}
function N(t, n) {
  return !!(n.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_PRECEDING);
}
export {
  C as canUseDOM,
  l as contains,
  E as getActiveElement,
  u as getDocument,
  p as getScrollingElement,
  O as getTextboxSelection,
  v as getTextboxValue,
  y as isButton,
  b as isFrame,
  f as isTextField,
  T as isTextbox,
  S as isVisible,
  x as sortBasedOnDOMPosition
};
//# sourceMappingURL=DTR5TSDJ.js.map
